import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AccountGuard} from './core/auth/account.guard';
import {LogoutGuard} from './core/auth/logout.guard';
import {Error404Component} from './core/views/error404/error404.component';
import {LogoutComponent} from './core/views/logout/logout.component';
import {footerRoute} from './layout/footer/footer.router';
import {headerRoute} from './layout/header/header.router';

const routes: Routes = [
  headerRoute,
  footerRoute,
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [LogoutGuard],
    canDeactivate: [LogoutGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: './modules/loading/loading.module#LoadingModule',
  },
  {
    path: 'convocatorias',
    loadChildren: './modules/convocatoria/convocatoria.module#ConvocatoriaModule',
  },
  {
    path: 'solicitantes',
    loadChildren: './modules/solicitantes/solicitantes.module#SolicitantesModule',
    canLoad: [AccountGuard],
  },
  {
    path: 'notificaciones',
    loadChildren: './modules/notificaciones/notificaciones.module#NotificacionesModule',
    canLoad: [AccountGuard],
  },
  {
    path: 'ficha-usuario',
    loadChildren: './modules/ficha-usuario/ficha-usuario.module#FichaUsuarioModule',
    canLoad: [AccountGuard],
  },
  {
    path: 'admision',
    loadChildren: './modules/admision/admision.module#AdmisionModule',
  },
  {
    path: 'adjudicacion',
    loadChildren: './modules/adjudicacion/adjudicacion.module#AdjudicacionModule',
    canLoad: [AccountGuard],
  },
  {
    path: 'reclamaciones-admision',
    loadChildren: './modules/reclamaciones/reclamaciones.module#ReclamacionesModule',
    canLoad: [AccountGuard],
  },
  {
    path: 'priuni',
    loadChildren: './modules/priuni/priuni.module#PriuniModule',
    // loadChildren: './modules/admision/admision.module#AdmisionModule',
  },
  {
    path: 'priuni-reclamaciones',
    loadChildren: './modules/priuni-reclamaciones/priuni-reclamaciones.module#PriuniReclamacionesModule',
  },
  {
    path: 'priuni-resultados',
    loadChildren: './modules/priuni-resultados/priuni-resultados.module#PriuniResultadosModule',
  },
  {path: '404', component: Error404Component},
  {path: '**', component: Error404Component},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
